import { render, staticRenderFns } from "./practiceBallSetting.vue?vue&type=template&id=7520a621&scoped=true"
import script from "./practiceBallSetting.vue?vue&type=script&lang=ts"
export * from "./practiceBallSetting.vue?vue&type=script&lang=ts"
import style0 from "./practiceBallSetting.vue?vue&type=style&index=0&id=7520a621&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7520a621",
  null
  
)

export default component.exports